// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__XugHu","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3_KRt"};